<template>
    <div class="user-files-project-hours">
        <h1>User Files Project Hours</h1>
        <div class="project-hours-container">
            <div class="stacked-chart"></div>
        </div>

          <vue-html2pdf :html-to-pdf-options="{
                showLayout: false,
                floatLayout: false,
                enableDownload: true,
                previewModal: false,
                paginateElementsByHeight: 1400,
                margin: 5,
                filename: fileName,
                pdfQuality: 2,
            
                jsPDF: {
                    unit: 'mm',
                    format: 'a4',
                    orientation: 'portrait'
                }
            }" :show-layout="false" :float-layout="false" :enable-download="true" :preview-modal="false"
                :paginate-elements-by-height="1400"
                :filename="'Krankheitstage-' + this.$moment(this.$getdate()).format('MMMM-YYYY') + '.pdf'" :pdf-quality="2" :margin="5"
                pdf-format="a4" pdf-orientation="portrait" pdf-content-width="730px"
                @hasStartedGeneration="hasStartedGeneration()" v-on:hasDownloaded="generatePFD = false" ref="html2Pdf">
                <section slot="pdf-content" class="pdf-content" >
                    <div class="horizontal-wrapper" style="width: 720px" :class="{ 'hide': !generatePFD }">
                        <div class="vertical-wrapper">
                            <h4>Dokumentation der</h4>
                            <h4>Projekt Stunden</h4>

                        </div>
                        <div class="vertical-wrapper">
                            <h4>Zeitraum:</h4>
                            <h4>{{ this.$moment(this.date).format(dateFormat) }}</h4>

                        </div>
                        <div class="placeholder"></div>
                        <div class="logo icon" style="flex: 0 0 100pt; ">
            
                        </div>
            
                    </div>
                    <div ref="chartbox" class="times-table">
            
                    </div>
            
                </section>
            
        </vue-html2pdf>
    </div>
</template>

<script type="text/javascript" src="https://www.gstatic.com/charts/loader.js"></script>
<script>

google.charts.load('current', {'packages':['corechart']});

import { API_BASE_URL } from '@/config/api'

export default {
    name: "UserFilesProjectHours",

    methods: {
        fetchProjectHours() {


            fetch(`${API_BASE_URL}/user-files/project-hours`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': this.$gettoken() // Replace with actual token
                },
                body: JSON.stringify({
                   
                    date: this.date,
                    userSelection: this.filteredUsers,
                }),
            }).then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                console.log('Response received:', response.status);
                
                return response.json();
            }).then(data => {
                console.log(data);
                data.forEach(e => {
                    e.project_hours = e.project_hours? e.project_hours: 0 
                    e.project_percentage = e.project_percentage? e.project_percentage: 0 


                })
                this.projectHours = data;

                this.renderChart()
            }).catch(error => {
                console.error('There was a problem with the fetch operation:', error);
            });
        },
        renderChart(){


            const projectHours = this.projectHours.map(e => { return [ e.name, e.worked_hours - e.project_hours, e.project_hours ] })
            
            const data = google.visualization.arrayToDataTable( [[{title: 'Angestellte', type: 'string'}, 'Stunden', 'ProjektStunden'], ...projectHours]  )
            /*
            var data = google.visualization.arrayToDataTable([
                ['Genre', 'Fantasy & Sci Fi', 'Romance', 'Mystery/Crime', 'General',
                'Western', 'Literature', { role: 'annotation' } ],
                ['2010', 10, 24, 20, 32, 18, 5, ''],
                ['2020', 16, 22, 23, 30, 16, 9, ''],
                ['2030', 28, 19, 29, 30, 12, 13, '']
            ]);
            */
             const options = {
                title: 'Projekt Stunden',
                //hAxis: { title: 'Angestellte' },
                vAxis: { title: 'ProjektStunden' },
                
                backgroundColor: '#fafafa',
                isStacked: true
            };

            const chart = new google.visualization.ColumnChart(this.$refs['chartbox']);
            chart.draw(data, options);

        }
    },  
     watch:{
        date(){
            this.fetchProjectHours()
        },
     
        
    },
    mounted() {
        console.log("UserFilesProjectHours component mounted");

        this.fetchProjectHours()
        
    },
    computed:{
        isadmin(){
            return this.$store.getters.isadmin
        },
        date(){
            return this.$store.getters.getDate
        },

        showNonActiveUsers(){
            return this.$store.getters.getShowNonActiveUsers
        },
        users(){
            return this.$store.getters.getUsers
        },
        filteredUsers(){
            return this.users.filter(e => (e.userActive || this.showNonActiveUsers) && e.showEvaluation) 
        },
        fileName(){
            return 'ProjektStunden-' + this.$moment(this.$getdate()).format('MMMM-YYYY') + '.pdf';
        }

    },
    data() {
        return {
            projectHours: [
                // Example data
             
            ],

        };
    },
};
</script>

<style scoped>
.user-files-project-hours {
    padding: 20px;
}

.project-hours-table {
    width: 100%;
    border-collapse: collapse;
}

.project-hours-table th,
.project-hours-table td {
    border: 1px solid #ddd;
    padding: 8px;
}

.project-hours-table th {
    background-color: #f4f4f4;
    text-align: left;
}
</style>